export default __webpack_public_path__ + "static/media/EuclidSquare-Italic.2537e631.woff";